export enum Action {
  /** Approved for an amount, which may be below the requested amount. */
  APPROVED = 'APPROVED',

  /** Rejected with a reason; nothing is authorized. */
  REJECTED = 'REJECTED',

  /** Sent back to draft; the earlier decision stays in the history. */
  REDRAFTED = 'REDRAFTED',
}
